import { getUserMailboxInfo } from 'owa-client-ids';
import { OcsSettingScope, OcsSettingType, OcsVersion, writeOcsSettings } from 'owa-ocs-service';
import type { OcsPatchEntry } from 'owa-ocs-service';
import type { DisplayOptions } from '../schema/DisplayOptions';

export default function saveOcsDisplaySetting(displayOptions: DisplayOptions) {
    const displayJSON = JSON.stringify(displayOptions);
    const ocsMiniThemePatch: OcsPatchEntry = {
        name: 'minidisplay',
        value: displayJSON,
        type: OcsSettingType.Json,
        scope: OcsSettingScope.Global,
        itemClass: 'RoamingSetting',
    };

    return writeOcsSettings(getUserMailboxInfo(), OcsVersion.V1, OcsSettingScope.Global, [
        ocsMiniThemePatch,
    ]);
}
